import type { TimeRange } from '../types/dashboard';

export type WidgetTimeframeToken = '24H' | '7D' | '30D' | '12M' | 'YTD';

export const DASHBOARD_INDEPENDENT_TIMEFRAME_WIDGET_IDS = [
  'totalFees',
  'winningVsLosing',
  'totalGainLoss',
  'averageDailyGainLoss',
  'totalCommissions',
  'numberOfWinningTrades',
  'numberOfLosingTrades',
] as const;

const independentTimeframeWidgetIds = new Set<string>(DASHBOARD_INDEPENDENT_TIMEFRAME_WIDGET_IDS);

const DASHBOARD_TIME_RANGE_DAYS: Record<TimeRange, number> = {
  week: 7,
  month: 30,
  year: 365,
};

const DASHBOARD_WIDGET_TIMEFRAMES: Record<TimeRange, WidgetTimeframeToken> = {
  week: '7D',
  month: '30D',
  year: '12M',
};

export function getDashboardTimeRangeDays(timeRange: TimeRange): number {
  return DASHBOARD_TIME_RANGE_DAYS[timeRange];
}

export function getDashboardWidgetTimeframe(timeRange: TimeRange): WidgetTimeframeToken {
  return DASHBOARD_WIDGET_TIMEFRAMES[timeRange];
}

export function getWidgetTimeframeTrailingDays(timeframe: WidgetTimeframeToken): number {
  if (timeframe === '24H') return 1;
  if (timeframe === '7D') return 7;
  if (timeframe === '30D') return 30;
  return 365;
}

export function hasIndependentDashboardTimeframe(widgetId: string): boolean {
  return independentTimeframeWidgetIds.has(widgetId);
}
